import ChipInSuccess from './chip_in_complete'
import { getValues } from 'redux-form'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  let { amount } = getValues(state.form.chip_in) || {}

  return {
    title: campaign.title,
    amount: amount,
    currency: campaign.currency,
    error: campaign.err,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChipInSuccess)
